// extracted by mini-css-extract-plugin
module.exports = {"image":"a10a3f92e9--image--HCbCM"};